var map = {
	"./new_s_default.json": [
		93143,
		3143
	],
	"./new_s_default_eur.json": [
		71075,
		1075
	],
	"./new_s_default_gbp.json": [
		51810,
		1810
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 91399;
module.exports = webpackAsyncContext;